export default {
  title: 'Subir imagen',
  cropHeader: 'Recorta la imagen de cabecera',
  cropThumbnail: 'Recorta la imagen de miniatura',
  cancel: 'Cancelar',
  back: 'Volver',
  next: 'Siguiente',
  uploadImages: 'Subir imágenes'
}

export const en = {
  title: 'Upload image',
  cropHeader: 'Crop header image',
  cropThumbnail: 'Crop thumbnail image',
  cancel: 'Cancel',
  back: 'Back',
  next: 'Next',
  uploadImages: 'Upload images'
}

export const ca = {
  title: 'Pujar imatge',
  cropHeader: 'Retalla la imatge de capçalera',
  cropThumbnail: 'Retalla la imatge de miniatura',
  cancel: 'Cancelar',
  back: 'Torna',
  next: 'Següent',
  uploadImages: 'Pujar imatges'
}
